import { render, staticRenderFns } from "./InputInboxApproval.vue?vue&type=template&id=6b265e9b&"
import script from "./InputInboxApproval.vue?vue&type=script&lang=js&"
export * from "./InputInboxApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports